<template>
  <div class="activity-item">
    <router-link :to="{ name: 'activities-show', params: { id: activity.id }}">
      <img class="main-image" :src="activity.image" alt="" @load="imgLoad">
    </router-link>
    <div class="info">
      <h4>{{activity.name}}</h4>
      <p>
        <img class="icon" src="../assets/images/icon_age.png" alt="">
        {{activity.age_period}}
      </p>
      <p>
        <img class="icon" src="../assets/images/icon_clock.png" alt="">
        {{activity.time}}
      </p>
    </div>
  </div>
</template>

<script>

export default {
  name: "ActivityItem",
  components: {
  },
  props: ['activity'],
  methods: {
      imgLoad() {
          this.$emit("onImageLoad")
      }
  }
};
</script>

<style lang="scss" scoped>
  .activity-item {
    margin-bottom: 20px;
    .main-image {
      width: 100%;
      vertical-align: bottom;
    }

    .info {
      padding: 20px;
      background: #fff;
      text-align: center;

      h4 {
        font-size:36px;
        font-weight: 600;
        margin-top: 20px;
        margin-bottom: 30px;
      }

      p {
        font-size: 24px;
        color: #9b9b9b;
        padding-bottom: 30px;

        .icon {
          width: auto;
          height: 36px;
          margin-right: 10px;
          vertical-align: middle;
        }
      }
    }
  }
</style>
